import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectDataUser } from 'connect/selectors';

import { EXPERIMENTS } from 'utils/constants/experiment-configs';
import { useExperiment } from 'utils/customHooks/useExperiment';

import { FunnelProvider } from '../../../../funnel/storage/Storage';
import { PartnerMatchProvider } from '../../../../partner/storage/Storage';
import CheckoutModalStepHandler from '../CheckoutModalStepHandler/CheckoutModalStepHandler';

export const CheckoutModal = () => {
  // We don't need the value from useExperiment, just the tracking
  useExperiment({ experiment: EXPERIMENTS.CHECKOUT_REDESIGN });

  const user = useSelector(selectDataUser);
  const isPartner = useMemo(() => Boolean(user?.partner), [user?.partner]);

  const Provider = useMemo(
    () => (isPartner ? PartnerMatchProvider : FunnelProvider),
    [isPartner],
  );

  return (
    <Provider>
      <CheckoutModalStepHandler isPartner={isPartner} />
    </Provider>
  );
};
